import React, { useEffect, useMemo, useState } from "react";
import {
  AssignTable,
  Button,
  FormFieldSet,
  NewTableAdv,
  LogoLoader,
  StatusTags,
  DropdownMenu,
  showToast,
  Backdrop,
  TableAdv
} from "../../../../components";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
//import AccrodianComponent from "../../../InnerPages/ComponentsList/List/TableList/AccrodianComponent";
import { useDispatch, useSelector } from "react-redux";
import { mapTableRows } from "../../../../utils";
import {
  clearFollowAssignData,
  getFollowAssignDataStart,
} from "../../../../redux/slices/compaigns/compaignsSlice";
import dayjs from "dayjs";
import { usePagination } from "../../../../hooks";
//import { bdmReportsStart } from "../../../../redux/slices/reports/reportsSlice";
import JSZip from "jszip";
import * as XLSX from "xlsx";
import { getProspectsStart } from "../../../../redux/slices/leads/leadsSlice";
import { convertFromUTC,convertToUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";

const BdmReports = ({ selectedReport, setSelectedReport }) => {
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const followData = useSelector(
    (state) => state.compaigns.assignData?.followData
  );
  const [outputData, setOutputData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [selectedBDMs, setSelectedBDMs] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  // console.log(value, "value ")
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );
// const [dateRange, setDateRange] = useState(() => {
//   const today = new Date();
//   const before10Days = new Date();
//   before10Days.setDate(today.getDate() - 10);

//   return {
//     from: today.toISOString().split("T")[0],
//     to: today.toISOString().split("T")[0],
//   }; 
// });


//propects
////////////////////////
 const { userData: loginUserData } = useLoginUser();
  const totalCountpProspects = value?.prospectsCounts?.data || 0;
  const [fromDate, setFromDate] = useState(
    // convertToUTC(dayjs().startOf("day").format("YYYY-MM-DD HH:mm"))
  );
  const [toDate, setToDate] = useState(
    // convertToUTC(dayjs().endOf("day").format("YYYY-MM-DD HH:mm"))
  );
  const [jobStatus, setJobStatus] = useState("");
  const prospectsData = useSelector(
    (state) => state.leads.prospects.data || []
  );
  const userRoleType = loginUserData?.role?.type;
  const level = loginUserData?.level;
  const loading = useSelector(
    (state) => state.leads.loading || false
  );
  // console.log(loading)
   const columnsProspects = [
      // {
      //   key: "pId",
      //   label: "ID",
      //   render: (row) => <div className="text-info">{row.id}</div>,
      // },
      {
        key: "raName",
        label: "RA Name",
      },
      {
        key: "clientName",
        label: "Client Name",
      },
      {
        key: "jobPosition",
        label: "Job Position",
      },
      {
        key: "jobLocation",
        label: "Job Location",
      },
      {
        key: "bdmName",
        label: "BDM Name",
      },
      {
        key: "bdmResponseDate",
        label: "BDM Response Date",
      },
      {
        key: "leadDate",
        label: "Lead Date",
      },
      {
        key: "jobStatus",
        label: "Job Status",
        render: (row) => {
          return (
            <StatusTags
              tag={row.jobStatus}
              className={
                row.jobStatus === "Closed"
                  ? " !bg-danger-500 text-white"
                  : "bg-success-500 text-white"
              }
            />
          );
        },
      },
    ];

     const JobStatus = {
    1: "Active",
    2: "Positive",
    3: "Open",
    4: "On Hold", // job posting status
    5: "Hold by Client",
    6: "Interview L1",
    7: "Interview L2",
    8: "Interview L3",
    9: "Priority",
    10: "Filled",
    11: "Closed",
    12: "Agreement Sent",
    13: "Agreement Accepted",
  };

   const mappedRowsProspects = mapTableRows(
      prospectsData.map((item, index) => {
        return {
          id: item?._id || index + 1,
          raName: formatWords2(item.addedBy?.firstName),
          clientName: formatWords2(item.companyId?.name),
          jobPosition: formatWords2(item.title),
          // jobLocation: `${item.location?.city || ""}, ${
          //   item.location?.state || ""
          // }`,
          jobLocation: [item.location?.city, item.location?.state]
            .filter(Boolean)
            .join(", "),
          bdmName: formatWords2(item.modifiedBy?.firstName),
          // bdmResponseDate: item.modifiedOn,
          // leadDate: item.addedOn,
          bdmResponseDate: convertFromUTC(item.modifiedOn),
          leadDate: convertFromUTC(item.addedOn),
          jobStatus: JobStatus[item.status] || "Unknown",
        };
      }),
      columnsProspects
    );
  
    useEffect(() => {
      let filters = { modifiedBy: { type: "EXISTS", value: true } };
      if (userRoleType !== 1 && level !== 5) {
        filters.addedBy = {
          type: "NONE",
          value: userRoleType !== 1 && level !== 5 ? loginUserData?.uiid : "",
        };
      }
      if (fromDate && toDate) {
        filters = {
          ...filters,
          modifiedOn: {
            type: "DATE_RANGE",
            value: {
              // from: dayjs(fromDate).startOf("day").toISOString(),
              // to: dayjs(toDate).endOf("day").toISOString(),
              from: getStartOfDay(fromDate),
              to: getEndOfDay(toDate),
            },
          },
        };
      }
      if (jobStatus && jobStatus.length > 0) {
        filters.status = {
          type: "IN",
          value: jobStatus,
        };
      }
      dispatch(
        totalCountStart({
          collection: "jobs",
          coll: "Job",
          tname: "prospectsCounts",
          filters: filters,
          app: "ats",
        })
      );
      const action = {
        coll: "Job",
        lim: limit,
        pg: page,
        ret: "uiid title addedBy addedOn companyId location status description modifiedBy modifiedOn",
        ref: "Company",
        fil: JSON.stringify(filters),
        extret: "uiid firstName",
        incl: ["name"],
        useAggregate: false,
        sort: JSON.stringify({ modifiedOn: -1 }),
      };
      dispatch(getProspectsStart(action));
    }, [dispatch, page, limit, fromDate, toDate,jobStatus]);
  
  ///////////////////////

  // const [showOptions, setShowOptions] = useState(false);
  const [submissionRows, setSubmissionRows] = useState([]);
  //const bdmReportsData = useSelector((state) => state.reports) || {};
  

  const handleDateChange = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
  };

  const fetchFollowAssignments = (date) => {
    const filterDate = date || dayjs().format("YYYY-MM-DD");
    const filter = { date: { type: "NONE", value: filterDate } };

    dispatch(clearFollowAssignData());

    dispatch(
      getFollowAssignDataStart({
        coll: "Shuffle",
        lim: 1,
        pg: 1,
        ref: "Jobwithcompany Propects",
        extret: "uiid firstName email lastName level",
        fil: JSON.stringify(filter),
        sort: JSON.stringify({ uiid: -1 }),
        extincl: JSON.stringify(["uiid"]),
      })
    );
  };

  // const handleDateRangeChange = (range) => {
  //   if (!range || !range.from || !range.to) return;
  //   // const fromISO = range.from.toISOString();
  //   // const toISO = range.to.toISOString();
  //   const fromISO = range.from
  //     ? convertToUTC(dayjs(range.from).startOf("day").format("YYYY-MM-DD HH:mm"))
  //     : null;

  //   const toISO = range.to
  //     ? convertToUTC(dayjs(range.to).endOf("day").format("YYYY-MM-DD HH:mm"))
  //     : null;

  //   setDateRange({
  //     from: fromISO,
  //     to: toISO,
  //   });

  // };

  useEffect(() => {
    if (
      selectedReport === "reports_ats_bdmreport_clientengagementreport" &&
      selectedDate
    ) {
      fetchFollowAssignments(selectedDate);
    }
  }, [selectedReport, selectedDate, dispatch]);

  const handleDownloadAssignments = async (data, type = "csv", selectedBDMs = []) => {
    if (!selectedBDMs || selectedBDMs.length === 0) {
      showToast("Please select at least one BDM before downloading.","error");
      return;
    }
    try {
      let bdmList = [];
      let teamList = [];

      if (Array.isArray(data)) {
        bdmList = data.map((d) => d.bdm);
        teamList = data.flatMap((d) => {
          const allTeams = [];
          Object.values(d.teams || {}).forEach((teamGroup) => {
            allTeams.push(...teamGroup.map((t) => ({ ...t, assignedTo: d.bdm.id })));
          });
          return allTeams;
        });
      } else {
        bdmList = data.bdmList || [];
        teamList = data.teamList || [];
      }

      const currentDate = new Date().toISOString().split("T")[0];
      const zip = new JSZip();
  
      const filteredBDMs = selectedBDMs.length
        ? bdmList.filter((b) => selectedBDMs.includes(b.id))
        : bdmList;
  
      const downloadBlob = (blob, filename) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      };
  //     const buildRowsForBDM = (bdmId) => {
  //       const bdm = bdmList.find((b) => b.id === bdmId);
  //       const bdmTeams = teamList.filter((t) => t.assignedTo === bdm.id);
  //       const rows = [];

  //       bdmTeams.forEach((teamMember) => {
  //         teamMember.jobProspects?.forEach((jp) => {
  //           const job = jp.jobId || {};
  //           const company = job.companyId?.[0] || {};
  //           const prospect = jp.prospectId || {};
  //           const addedBy = job.addedBy || {};
  //           const location = job.location || {};
  
  //           rows.push({
  //             assignBDMName: bdm.name || "",
  //             addedByRaName: `${addedBy.firstName || ""} ${addedBy.lastName || ""}`.trim(),
  //             companyName: company.name || "",
  //             jobTitle: job.title || "",
  //             jobLocation: [location.city, location.state, location.country].filter(Boolean).join(", "),
  //             jobDescription: job.description || "",
  //             jobWebsite: company.website || "",
  //             contactFirstName: prospect.firstName || "",
  //             contactLastName: prospect.lastName || "",
  //             contactDesignation: prospect.designation || "",
  //             contactEmail: prospect.email || "",
  //             // contactPhoneNumber: prospect.mobile?.number || "",
  //             contactPhoneNumber: prospect.mobile
  // ? `${prospect.mobile.code || ""} ${prospect.mobile.number || ""}`.trim()
  // : "",
  //             preStatus: "", // left blank intentionally
  //           });
  //         });
  //       });
  //       return rows;
  //     }; 
      const buildRowsForBDM = (bdmId) => {
        const bdm = bdmList.find((b) => b?.id === bdmId);
        const bdmTeams = teamList.filter((t) => t?.assignedTo === bdm?.id);
        const rows = [];

        bdmTeams.forEach((teamMember) => {
          if (Array.isArray(teamMember.jobProspects) && teamMember.jobProspects.length > 0) {
            teamMember.jobProspects.forEach((jp) => {
              const job = jp?.jobId || {};
              const company = job?.companyId?.[0] || {};
              const prospect = jp?.prospectId || {};
              const addedBy = job?.addedBy || {};
              const location = job?.location || {};

              rows.push({
                assignBDMName: formatWords2(bdm?.name || ""),
                addedByRaName: `${formatWords2(addedBy?.firstName || "")} ${formatWords2(addedBy?.lastName || "")}`.trim(),
                companyName: formatWords2(company?.name || ""),
                jobTitle: formatWords2(job?.title || ""),
                jobLocation: [location?.city, location?.state, location?.country].filter(Boolean).join(", "),
                jobDescription: job?.description || "",
                jobWebsite: company?.website || "",
                contactFirstName: formatWords2(prospect?.firstName || ""),
                contactLastName: formatWords2(prospect?.lastName || ""),
                contactDesignation: formatWords2(prospect?.designation || ""),
                contactEmail: prospect?.email || "",
                contactPhoneNumber: prospect?.mobile
                  ? `${prospect?.mobile?.code || ""} ${prospect?.mobile?.number || ""}`.trim()
                  : "",
                // preStatus: "",
              });
            });
          } else {
            rows.push({
              assignBDMName: formatWords2(bdm?.name || ""),
              addedByRaName: formatWords2(teamMember?.name || ""),
              companyName: "",
              jobTitle: "",
              jobLocation: "",
              jobDescription: "",
              jobWebsite: "",
              contactFirstName: "",
              contactLastName: "",
              contactDesignation: "",
              contactEmail: "",
              contactPhoneNumber: "",
              // preStatus: "",
            });
          }
        });

        return rows;
      };

      if (filteredBDMs.length > 1) {
        for (const bdm of filteredBDMs) {
          const rows = buildRowsForBDM(bdm.id);
          if (!rows.length) continue;
  
          const ws = XLSX.utils.json_to_sheet(rows);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Data");
  
          const bdmFileName = `${bdm.name.replace(/\s+/g, "_")}_${currentDate}`;
          if (type === "excel") {
            const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            zip.file(`${bdmFileName}.xlsx`, buffer);
          } else {
            const csv = XLSX.utils.sheet_to_csv(ws);
            zip.file(`${bdmFileName}.csv`, csv);
          }
        }
  
        const zipBlob = await zip.generateAsync({ type: "blob" });
        downloadBlob(zipBlob, `RATeamData_${currentDate}.zip`);
      }
      else if (filteredBDMs.length === 1) {
        const bdm = filteredBDMs[0];
        const rows = buildRowsForBDM(bdm.id);
        if (!rows.length) return;
  
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");
  
        const fileName = `${bdm.name.replace(/\s+/g, "_")}_${currentDate}`;
        if (type === "excel") {
          const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          downloadBlob(blob, `${fileName}.xlsx`);
        } else {
          const csv = XLSX.utils.sheet_to_csv(ws);
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          downloadBlob(blob, `${fileName}.csv`);
        }
      }
    } catch (err) {
      console.error("Error while generating download:", err);
    }
  };
//   const handleDownloadAssignments = async (data, type = "csv", selectedBDMs = []) => {
//   console.log("🟢 Starting download for:", { data, type, selectedBDMs });

//   try {
//     if (!selectedBDMs || selectedBDMs.length === 0) {
//       console.warn("⚠️ No BDMs selected — returning early.");
//       showToast("Please select at least one BDM before downloading.", "error");
//       return;
//     }

//     if (!data) {
//       console.error("❌ Data is null or undefined.");
//       return;
//     }

//     // const { bdmList = [], teamList = [] } = data;
//     // console.log("📦 Data lengths:", { bdmList: bdmList.length, teamList: teamList.length });

//     // if (!bdmList.length || !teamList.length) {
//     //   console.warn("⚠️ Empty bdmList or teamList — returning early.");
//     //   return;
//     // }
//     let bdmList = [];
// let teamList = [];

// if (Array.isArray(data)) {
//   // The structure matches AssignTable output
//   bdmList = data.map((d) => d.bdm);
//   teamList = data.flatMap((d) => {
//     const allTeams = [];
//     Object.values(d.teams || {}).forEach((teamGroup) => {
//       allTeams.push(...teamGroup.map((t) => ({ ...t, assignedTo: d.bdm.id })));
//     });
//     return allTeams;
//   });
// } else {
//   // fallback if data is in old format
//   bdmList = data.bdmList || [];
//   teamList = data.teamList || [];
// }

// console.log("📦 Normalized data:", { bdmList: bdmList.length, teamList: teamList.length });


//     const currentDate = new Date().toISOString().split("T")[0];
//     const zip = new JSZip();

//     const filteredBDMs = selectedBDMs.length
//       ? bdmList.filter((b) => selectedBDMs.includes(b.id))
//       : bdmList;

//     console.log("👥 Filtered BDMs:", filteredBDMs.map((b) => b.name));

//     const downloadBlob = (blob, filename) => {
//       console.log("💾 Triggering file download:", filename, blob.type, blob.size);
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);
//       link.href = url;
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
//     };

//     const buildRowsForBDM = (bdmId) => {
//       const bdm = bdmList.find((b) => b.id === bdmId);
//       if (!bdm) {
//         console.warn("⚠️ BDM not found for id:", bdmId);
//         return [];
//       }
//       const bdmTeams = teamList.filter((t) => t.assignedTo === bdm.id);
//       console.log(`📊 Building rows for ${bdm.name} (teams: ${bdmTeams.length})`);

//       const rows = [];
//       bdmTeams.forEach((teamMember) => {
//         teamMember.jobProspects?.forEach((jp) => {
//           const job = jp.jobId || {};
//           const company = job.companyId?.[0] || {};
//           const prospect = jp.prospectId || {};
//           const addedBy = job.addedBy || {};
//           const location = job.location || {};

//           rows.push({
//             assignBDMName: bdm.name || "",
//             addedByRaName: `${addedBy.firstName || ""} ${addedBy.lastName || ""}`.trim(),
//             companyName: company.name || "",
//             jobTitle: job.title || "",
//             jobLocation: [location.city, location.state, location.country].filter(Boolean).join(", "),
//             jobDescription: job.description || "",
//             jobWebsite: company.website || "",
//             contactFirstName: prospect.firstName || "",
//             contactLastName: prospect.lastName || "",
//             contactDesignation: prospect.designation || "",
//             contactEmail: prospect.email || "",
//             contactPhoneNumber: prospect.mobile?.number || "",
//           });
//         });
//       });
//       console.log(`✅ ${rows.length} rows built for ${bdm.name}`);
//       return rows;
//     };

//     if (filteredBDMs.length > 1) {
//       console.log("🗂 Multiple BDMs selected — creating ZIP");
//       for (const bdm of filteredBDMs) {
//         const rows = buildRowsForBDM(bdm.id);
//         if (!rows.length) {
//           console.warn(`⚠️ No rows for ${bdm.name}`);
//           continue;
//         }

//         const ws = XLSX.utils.json_to_sheet(rows);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Data");

//         const bdmFileName = `${bdm.name.replace(/\s+/g, "_")}_${currentDate}`;
//         if (type === "excel") {
//           const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//           zip.file(`${bdmFileName}.xlsx`, buffer);
//         } else {
//           const csv = XLSX.utils.sheet_to_csv(ws);
//           zip.file(`${bdmFileName}.csv`, csv);
//         }
//       }

//       console.log("📦 Generating ZIP...");
//       const zipBlob = await zip.generateAsync({ type: "blob" });
//       downloadBlob(zipBlob, `RATeamData_${currentDate}.zip`);
//       console.log("✅ ZIP download triggered.");
//     } else if (filteredBDMs.length === 1) {
//       const bdm = filteredBDMs[0];
//       console.log("📁 Single BDM selected:", bdm.name);

//       const rows = buildRowsForBDM(bdm.id);
//       if (!rows.length) {
//         console.warn("⚠️ No rows found for selected BDM.");
//         return;
//       }

//       const ws = XLSX.utils.json_to_sheet(rows);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Data");

//       const fileName = `${bdm.name.replace(/\s+/g, "_")}_${currentDate}`;
//       if (type === "excel") {
//         const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//         const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//         downloadBlob(blob, `${fileName}.xlsx`);
//       } else {
//         const csv = XLSX.utils.sheet_to_csv(ws);
//         const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//         downloadBlob(blob, `${fileName}.csv`);
//       }
//       console.log("✅ Single BDM file download triggered.");
//     } else {
//       console.warn("⚠️ No filtered BDMs matched.");
//     }
//   } catch (err) {
//     console.error("❌ Error while generating download:", err);
//   }
// };

  const memoizedData = useMemo(() => {
    if (!followData || !Array.isArray(followData))
      return { bdmList: [], teamList: [] };

    const filtered = followData.filter(
      (item) => dayjs(item.date).format("YYYY-MM-DD") === selectedDate
    );

    if (!filtered.length) return { bdmList: [], teamList: [] };

    const latestData = filtered.sort(
      (a, b) => (b.version || 0) - (a.version || 0)
    )[0];

    if (!latestData?.shuffle) return { bdmList: [], teamList: [] };

    const bdms = [];
    const teamList = [];

    latestData.shuffle.forEach((shuffleItem, bdmIndex) => {
      const bdmObj = shuffleItem.BdmId || {
        uiid: `bdm-${bdmIndex}`,
        firstName: "Unknown",
        lastName: "",
        email: { primary: "" },
      };

      if (!bdms.some((b) => b.id === bdmObj.uiid)) {
        bdms.push({
          id: bdmObj.uiid,
          name: `${formatWords2(bdmObj.firstName)} ${formatWords2(bdmObj.lastName)}`.trim(),
          email: bdmObj.email?.primary || "",
        });
      }

      shuffleItem.assignedProspectData?.forEach((p, idx) => {
        const raObj = p.raId || {
          uiid: `ra-${idx}`,
          firstName: "RA",
          level: 1,
        };
        const level = Number(raObj.level) || 1;
        let designation = "fresher";
        if ([3, 4, 5].includes(level)) designation = "senior";
        else if (level === 2) designation = "junior";

        const prospectEntries =
          p.prospectId !== null
            ? [
                {
                  // jobId: p.prospectId.jobIds?.[0],
                  jobId: p.jobId,
                  prospectId: p.prospectId,
                },
              ]
            : [];
              // console.log("p.jobId?.companyId",p.jobId?.companyId)
        teamList.push({
          id: raObj.uiid,
          key: `team-${bdmObj.uiid}-${idx}`,
          name: formatWords2(raObj.firstName),
          company: p.jobId?.companyId?.[0]?.name || "",
          location: p.jobId?.location?.city || "",
          prospectCount: prospectEntries.length,
          assignedTo: bdmObj.uiid,
          designation,
          jobProspects: prospectEntries,
        });
      });
    });

    return { bdmList: bdms, teamList };
  }, [followData, selectedDate]);

  const handleAssignmentOutput = (output) => {
    // console.log("AssignTable output:", output);
    setOutputData(output);
  };
  const handleSelectionChange = (selectedIds) => {
    setSelectedBDMs(selectedIds);
  };
  if (selectedReport.tempRepId === "bdm_downloade_sheet") {
    return (
      <div className="flex-1 flex flex-col overflow-hidden p-4">
        <div className="flex items-center justify-between mb-3">
          <Button
            title="Client Engagement Report"
            color="black"
            variant="text"
            size="md"
            fromLeft
            icon="arrow_left_alt"
            className="text-lg font-semibold"
            onClick={() => setSelectedReport(null)}
          />

          {/* <FormFieldSet
            noTitle
            type="datepicker"
            placeholder="Select Date"
            value={selectedDate}
            onChange={handleDateChange}
          /> */}
        </div>

        {loading ? (
          <div className="text-center py-10 text-gray-500">Loading data...</div>
        ) : memoizedData.bdmList.length === 0 &&
          memoizedData.teamList.length === 0 ? (
          <div className="text-center py-10 text-gray-500">
            No data available for this date
          </div>
        ) : (
          <AssignTable
            data={memoizedData}
            type="followup"
            output={handleAssignmentOutput}
            loading={loading}
            showCheckbox={true}
            onSelectionChange={handleSelectionChange}
            toolbarRight = {{
              add: [
                {
                component: (
                  <div>
                    <DropdownMenu
                      MenuSection={
                        <div className="flex flex-col">
                          <Button
                            title={"Download as excel"}
                            variant="text"
                            color="black"
                            className="!justify-start py-1"
                            onClick={() => handleDownloadAssignments(outputData, "excel", selectedBDMs)}
                          />
                          <Button
                            title={"Download as csv"}
                            variant="text"
                            color="black"
                            className="!justify-start py-1"
                            onClick={() => handleDownloadAssignments(outputData, "csv", selectedBDMs)}
                          />
                        </div>
                      }
                    >
                      <Button
                        icon="download"
                        type="icon"
                        variant="text"
                        color="black"
                      />
                    </DropdownMenu>
                  </div>
                )}
              ],
            }}
          />
        )}
      </div>
    );
  }

  //const totalCount = value?.bdmReports?.data || 0;
  // console.log(totalCount, "tc")
  const reportOptions = [
    {
      id: "reports_ats_bdmreport_bdmsummaryreport",
      name: "BDM Summary Report",
    },
    {
      id: "reports_ats_bdmreport_clientengagementreport",
      name: "BDM Download Sheets",
    },
    // {
    //   id: "reports_ats_bdmreport_bdmperformancereport",
    //   name: "BDM Performance Report",
    // },
    // {
    //   id: "reports_ats_bdmreport_leadconversionreport",
    //   name: "Lead Conversion Report",
    // },
    // {
    //   id: "reports_ats_bdmreport_clientfollowupreport",
    //   name: "Client Follow-up Report",
    // },
  ];

  const rows = reportOptions.slice(0, 2).map((report, i) => ({
    id: i + 200,
    reportName: report,
    category: "BDM",
    type: "Standard Reports",
  }));

  const columns = [
    {
      key: "reportName",
      label: "Report Name",
      render: (row) => (
        <div
          className="text-blue-600 cursor-pointer"
          onClick={() => setSelectedReport(row?.reportName?.id)}
        >
          {row?.reportName?.name}
        </div>
      ),
    },
    { key: "category", label: "Category" },
    { key: "type", label: "Type" },
    {
      key: "Favourite",
      label: "Favourite",
      render: () => (
        <Button
          type="icon"
          icon="star"
          variant="text"
          size="md-lg"
          color="black"
          className="text-gray-400"
        />
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);

  // const columns2 = [
  //   { key: "id", label: "ID", render: (row) => <div className="text-blue-600">{row.id}</div> },
  //   { key: "date", label: "Date", render: (row) => <div className="text-blue-600">{row.date}</div> },
  //   { key: "clientname", label: "Client Name", render: (row) => <div className="text-blue-600">{row.clientname}</div> },
  //   { key: "jobposition", label: "Job Position", render: (row) => <div className="text-blue-600">{row.jobposition}</div> },
  //   { key: "bdmname", label: "BDM Name", render: (row) => <div className="text-blue-600">{row.bdmname}</div> },
  //   { key: "raname", label: "RA Name", render: (row) => <div className="text-blue-600">{row.raname}</div> },
  //   { key: "leaddate", label: "Lead date", render: (row) => <div className="text-blue-600">{row.leaddate}</div> },
  //   { key: "status", label: "Status", render: (row) => <StatusTags tag={row.status} /> },
  // ];

  // const fetchSubmissions = async () => {
  //   // if (!submissions?.length) return;

  //   try {
  //     const payload = {
  //       coll: "Job",
  //       pg: page,
  //       lim: limit,
  //       fil: {
  //         modifiedOn: {
  //           type: "DATE_RANGE", value: {
  //             from:
  //               dateRange.from,
  //             to: dateRange.to
  //           }
  //         }
  //       },
  //       extret: "uiid firstName",
  //       queryMode: "AG_TEAMCOUNT",
  //       ret: "uiid title addedBy status modifiedBy modifiedOn addedOn",
  //       ref: "Company",
  //       incl: ["uiid name"]

  //     };
  //     dispatch(bdmReportsStart(payload))
  //   } catch (err) {
  //     console.error("Error fetching submissions:", err);
  //   } finally {
  //   }
  // };

  // 2) listen for bdmReportsData changes and map rows when it arrives
  // useEffect(() => {
  //   const data = bdmReportsData?.bdmReports?.data;
  //   if (!data || !Array.isArray(data) || data.length === 0) {
  //     setSubmissionRows([]); // clear if no data
  //     return;
  //   }
  //  // console.log(data, "data")
  //   const formattedRows = data.map((item, index) => {
  //     const addedBy =
  //       typeof item.addedBy === "object" && item.addedBy
  //         ? item.addedBy
  //         : { uiid: item.addedBy || null };

  //     return {
  //       id: index + 1,
  //       date: item.modifiedOn ? new Date(item.modifiedOn).toLocaleDateString() : "-",
  //       clientname: item.companyId?.name ?? "-",
  //       jobposition: item.title ?? "-",
  //       bdmname: item.modifiedBy?.firstName ?? "-",
  //       raname: addedBy.firstName ?? "-",
  //       leaddate: item.addedOn ? new Date(item.addedOn).toLocaleDateString() : "-",
  //       status:
  //         item.status === 1
  //           ? "Verified"
  //           : item.status === 2
  //             ? "In Progress"
  //             : item.status === 3
  //               ? "Rejected"
  //               : item.status === 4
  //                 ? "Pending"
  //                 : "Unknown",
  //     };
  //   });

  //   setSubmissionRows(mapTableRows(formattedRows, columns2));
  // }, [bdmReportsData]); // run when redux slice changes


  // useEffect(() => {
  //   dispatch(
  //     totalCountStart({
  //       collection: "jobs",
  //       coll: "Job",
  //       tname: "bdmReports",
  //       filters: {
  //         modifiedOn: {
  //           type: "DATE_RANGE", value: {
  //             from:
  //               dateRange.from,
  //             to: dateRange.to
  //           }
  //         }
  //       },
  //       app: "ats",
  //     })
  //   );
  //   fetchSubmissions();
  // }, [dispatch, dateRange.to, dateRange.from, limit, page]);


  // if (selectedReport) {
    // const reportData = rows.find((r) => r.reportName.id === selectedReport);

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Button
        title="BDM Summary Report"
        color="black"
        variant="text"
        size="md"
        fromLeft
        icon="arrow_left_alt"
        className="text-lg font-semibold"
        onClick={() => setSelectedReport(null)}
      />
      <div className="flex-1 overflow-auto shadow-tableset overflow-hidden flex flex-col">
        <TableAdv
          showCheckbox
          columns={columnsProspects}
          rows={mappedRowsProspects}
          serverPagination={true}
          totalCount={totalCountpProspects || 0}
          page={page}
          showSlNo
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          tableId={"reports_ats_bdmreport_clientengagementreport"}
          info={"info"}
          onSelectionChange={setSelectedRows}
          defaultSelectedRows={selectedRows}
          toolbarRight={{
            fullScreen: true,
            add: [
              {
                component: (
                  <>
                    <FormFieldSet
                      noTitle
                      placeholder="Select date range"
                      type="datepickerRange"
                      size="sm"
                      value={{
                        from: fromDate,
                        to: toDate,
                      }}
                      onChange={(range) => {
                        if (range?.from && range?.to) {
                          setFromDate(range?.from || null);
                          setToDate(range?.to || null);
                        }
                      }}
                    />
                    <div className="min-w-[150px]">
                      <FormFieldSet
                        type="select"
                        placeholder="Select"
                        noTitle
                        size="sm"
                        // options={[{ label: "Open", value: "1" }]}
                        options={[
                          { label: "Active", value: 1 },
                          { label: "Positive", value: 2 },
                          { label: "Open", value: 3 },
                          { label: "On Hold", value: 4 },
                          { label: "Hold by Client", value: 5 },
                          { label: "Interview L1", value: 6 },
                          { label: "Interview L2", value: 7 },
                          { label: "Interview L3", value: 8 },
                          { label: "Priority", value: 9 },
                          { label: "Filled", value: 10 },
                          { label: "Closed", value: 11 },
                          { label: "Agreement Sent", value: 12 },
                          { label: "Agreement Accepted", value: 13 },
                        ]}
                        value={jobStatus}
                        onChange={(value) => setJobStatus(value)}
                        multiple
                      />
                      <Backdrop isOpen={loading}>
                        <LogoLoader />
                      </Backdrop>
                    </div>
                  </>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
  // }

  // return (
  //   <div className="flex-1 flex flex-col overflow-hidden">
  //     <NewTableAdv
  //       disableSelection={true}
  //       columns={columns}
  //       rows={mappedRows}
  //       showCheckbox={false}
  //       showSlNo
  //       toolbarRight={{ search: true }}
  //       tableId={"bdmReportsTable"}
  //     />
  //   </div>
  // );
};

export default BdmReports;